import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ContainerOutlined,
} from '@ant-design/icons'
import { Button } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import styled from 'styled-components'

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 8px;
`

interface FlowCytometryReviewAnalysisConfigurationModalFooterProps {
  onCancel: () => void
  onNext?: () => void
  nextDisabled?: boolean
  onPrevious?: () => void
  onSubmit?: () => void
  submitDisabled?: boolean
  submitLoading?: boolean
}

const FlowCytometryReviewAnalysisConfigurationModalFooter = memo(
  ({
    onCancel,
    onNext,
    nextDisabled = false,
    onPrevious,
    onSubmit,
    submitDisabled = false,
    submitLoading = false,
  }: FlowCytometryReviewAnalysisConfigurationModalFooterProps) => {
    return (
      <Footer>
        <Button onClick={onCancel} type="text">
          {t('reviewAnalysisConfigurationModal.footer.cancel')}
        </Button>
        {onPrevious && (
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            onClick={onPrevious}
          >
            {t('reviewAnalysisConfigurationModal.footer.back')}
          </Button>
        )}
        {onNext && (
          <Button
            icon={<ArrowRightOutlined />}
            disabled={nextDisabled}
            type="primary"
            onClick={onNext}
          >
            {t('reviewAnalysisConfigurationModal.footer.next')}
          </Button>
        )}
        {onSubmit && (
          <Button
            key="submit"
            icon={<ContainerOutlined />}
            type="primary"
            onClick={onSubmit}
            disabled={submitDisabled}
            loading={submitLoading}
          >
            {t('reviewAnalysisConfigurationModal.footer.runAlgorithm')}
          </Button>
        )}
      </Footer>
    )
  }
)

export default FlowCytometryReviewAnalysisConfigurationModalFooter

